import React from 'react';
import IconBase from './shared/icon-base';
import { jsx as ___EmotionJSX } from "@emotion/core";
export default function PlusIcon(props) {
  return ___EmotionJSX(IconBase, props, ___EmotionJSX("path", {
    d: "M12.9853 10.9854H22.9853V12.9854H12.9853L12.9853 22.9853L10.9853 22.9853V12.9854L0.98529 12.9854L0.98529 10.9854L10.9853 10.9854L10.9853 0.985343L12.9853 0.985344L12.9853 10.9854Z",
    fill: "currentColor"
  }));
}